export default [
  {
    name: 'getAppUrl',
    method: 'post',
    desc: '获取新版本app下载地址',
    path: '/obt/getAppUrl',
    params: {
      appType: '',//app类型1安卓,2IOS ,
      appVersion: '',
      compId: '' 
    },
    loading: '0'
  },
  {
    name: 'getAppMsgPush',
    method: 'post',
    desc: '获取app推送的消息',
    path: '/obt/getAppMsgPush',
    params: {
      id: ''
    }
  },
  {
    name: 'saveAppTsInfo',
    method: 'post',
    desc: '保存app推送Id',
    path: '/obt/saveAppTsInfo',
    params: {
      tsCid: '',
      tsDevice: '',//1 安卓 2 ios
    },
    loading: '0'
  },
  {
    name: 'submitBug',
    method: 'post',
    desc: '上传后台接口错误',
    path: '/mqc/bugManage/submitBug',
    serveType: 'mqc',
    params: {
      // 'bugType': '', // BUG类型，1:后端BUG  2:WEBUI BUG 不传默认1
      // 'location': '',
      'level': '', // BUG严重级别
      'fromSys': '', // 来源
      'userAgent': '', // 浏览器或手机系统版本标识
      'corpName': '',
      'userName': '', // 当前操作用户名称+登录工号，eg：张三/8888
      'requuid': '', // 请求唯一标识，可以将此标识提供给技术人员，方便快速定位错误日志
      'reqPath': '', // 接口地址
      'pagePath': '',
      'moduleName': '', // 模块名称
      'funName': '', // 功能名称
      'env': '', // 环境
      'errCode': '', // 业务错误代码
      'errMsg': '', // 业务处理失败时，异常信息
      'tips': '', // 业务处理失败时，错误提示信息
      'reqData': '', // 请求参数对象
      'resData': '', // 返回业务数据对象，没有则为空
      'remark': '' // 问题操作步骤描述，前端可自行组织或者由用户填报录入
    },
    loading: '0'
  },
  {
    name: 'submitBug4Batch',
    method: 'post',
    desc: '上传后台接口错误',
    path: '/mqc/bugManage/submitBug4Batch',
    serveType: 'mqc',
    params: {
    },
    loading: '0'
  },
]